import { useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { appRouterPaths } from "@/services/navigation";
import { useAppDispatch } from "@/services/store";
import { setCurrentPerson } from "@/pages/ContactsPage/slice";
import type { Person } from "@/services/api";
import type { MaybeType } from "@/shared/types";
import type { ContactsListProps } from "../types";
import { filterContacts } from "../utils";

export const useContactsList = (
  contacts: ContactsListProps["contacts"],
  setSelectedPersonId: (id: string) => void,
) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const { personId } = useParams();

  const [nameFilter, setNameFilter] = useState<MaybeType<string>>(null);
  const [titleFilter, setTitleFilter] = useState<MaybeType<string>>(null);

  const handleChangeNameFilter = useCallback((value: MaybeType<string>) => {
    setNameFilter(value);
  }, []);

  const handleChangeTitleFilter = useCallback((value: MaybeType<string>) => {
    setTitleFilter(value);
  }, []);

  const filteredContacts = useMemo(() => {
    return filterContacts(contacts, nameFilter, titleFilter);
  }, [contacts, nameFilter, titleFilter]);

  const handleCreatePerson = useCallback(() => {
    setSelectedPersonId("TEMP_ID");
    navigate(`${appRouterPaths.contacts.genInfo.replace(":personId", "TEMP_ID")}`);

    // TODO: remove this after refactor connections table
    dispatch(setCurrentPerson(null));
  }, []);

  const handleRowClick = (record: Person) => {
    setSelectedPersonId(record.id);
    navigate(`${appRouterPaths.contacts.genInfo.replace(":personId", record.id)}`);
    // TODO: remove this after refactor connections table
    dispatch(setCurrentPerson(record));
  };

  useEffect(() => {
    if (personId) {
      setSelectedPersonId(personId);
    }
  }, [personId]);

  return {
    state: {
      nameFilter,
      titleFilter,
      filteredContacts,
    },
    methods: {
      handleChangeNameFilter,
      handleChangeTitleFilter,
      handleCreatePerson,
      handleRowClick,
    },
  };
};
